import Model from "../../Model";
//import { actions } from '@/store';

class stockProducts extends Model{

    buildUrl ({ param }) {
        return ['stock/products', param];
    }
}


export default new stockProducts;